import api, { API_URL } from './api';

export interface Documento {
  id?: number;
  socio_id: number;
  tipo_documento: string;
  nome_arquivo: string;
  caminho_arquivo: string;
  data_upload?: string;
  data_validade?: string;
  status?: string;
  observacoes?: string;
}

export interface DocumentoCreate {
  socio_id: number;
  tipo_documento: string;
  arquivo: File;
  data_validade?: string;
  observacoes?: string;
}

export interface DocumentoUpdate {
  tipo_documento?: string;
  arquivo: File;
  data_validade?: string;
  observacoes?: string;
}

// Mesma base do axios (proxy em dev)
const API_BASE_URL = API_URL;

export const documentoService = {
  async listar(params?: {
    socio_id?: number;
    tipo_documento?: string;
    status?: string;
  }): Promise<Documento[]> {
    const response = await api.get<Documento[]>('/api/documentos/', { params });
    return response.data;
  },

  async listarPorSocio(socio_id: number): Promise<Documento[]> {
    const response = await api.get<Documento[]>(`/api/documentos/socio/${socio_id}`);
    return response.data;
  },

  async obter(id: number): Promise<Documento> {
    const response = await api.get<Documento>(`/api/documentos/${id}`);
    return response.data;
  },

  async criar(dados: DocumentoCreate): Promise<Documento> {
    const formData = new FormData();
    formData.append('socio_id', dados.socio_id.toString());
    formData.append('tipo_documento', dados.tipo_documento);
    formData.append('arquivo', dados.arquivo);
    
    if (dados.data_validade) {
      formData.append('data_validade', dados.data_validade);
    }
    
    if (dados.observacoes) {
      formData.append('observacoes', dados.observacoes);
    }

    const response = await api.post<Documento>('/api/documentos/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async deletar(id: number): Promise<void> {
    await api.delete(`/api/documentos/${id}`);
  },

  async atualizar(id: number, dados: DocumentoUpdate): Promise<Documento> {
    const formData = new FormData();
    if (dados.tipo_documento) {
      formData.append('tipo_documento', dados.tipo_documento);
    }
    formData.append('arquivo', dados.arquivo);

    if (dados.data_validade) {
      formData.append('data_validade', dados.data_validade);
    }

    if (dados.observacoes) {
      formData.append('observacoes', dados.observacoes);
    }

    const response = await api.put<Documento>(`/api/documentos/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async downloadDocumento(id: number): Promise<void> {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_BASE_URL}/api/documentos/${id}/download`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    
    if (!response.ok) {
      throw new Error('Erro ao fazer download');
    }
    
    const blob = await response.blob();
    const documento = await this.obter(id);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = documento.nome_arquivo;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  },

  async getVisualizarBlobUrl(id: number): Promise<string> {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_BASE_URL}/api/documentos/${id}/visualizar`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    
    if (!response.ok) {
      throw new Error('Erro ao carregar documento');
    }
    
    const blob = await response.blob();
    return window.URL.createObjectURL(blob);
  },
};

